/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import Colors from 'constants/Colors';
import {FiraSansBold} from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;
`;

export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  `;

export const Text = styled.label`
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
`;
export const ButtonContent = styled.div`
    display:flex;
    flex-direction:row;
    justify-content: space-evenly;
    background-color:#FFF;  
    
    @media (max-width: ${Breakpoints.lg}) {  
      flex-wrap: wrap;
      padding-right: 10px;
      width: 100%;
    }
`;
